{
  "buttonLabel": "Näytä ehdotukset",
  "countAnnouncement": "{optionCount, plural, one {# vaihtoehto} other {# vaihtoehtoa}} saatavilla.",
  "focusAnnouncement": "{isGroupChange, select, true {Siirtyi ryhmään {groupTitle}, jossa {groupCount, plural, one {# vaihtoehto} other {# vaihtoehtoa}}.} other {}}{optionText}{isSelected, select, true {, valittu} other {}}",
  "listboxLabel": "Ehdotukset",
  "selectedAnnouncement": "{optionText}, valittu"
}
